import React from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";

const ProtocolTable = ({ protocolList }) => {
  const history = useHistory();
  const handleRowClik = (id) => history.push(`/protocolDetails/${id}`);
  return (
    <Container>
      <TableContainer component={Paper}>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>DATA</TableCell>
              <TableCell>TITULO</TableCell>
              <TableCell>ANONIMO?</TableCell>
              <TableCell>CLASSIFICAÇÃO</TableCell>
              <TableCell>UNIDADE</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {protocolList.map(
              ({ id, title, timestamp, name, classification, unity }) => (
                <TableRow
                  onClick={() => handleRowClik(id)}
                  key={id}
                  style={{ cursor: "pointer" }}
                >
                  <TableCell component="th" scope="row">
                    {new Date(parseInt(timestamp)).toLocaleDateString()}
                  </TableCell>
                  <TableCell>{title}</TableCell>
                  <TableCell>{name ? "NÃO" : "SIM"}</TableCell>
                  <TableCell>{classification}</TableCell>
                  <TableCell>{unity}</TableCell>
                </TableRow>
              )
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
};

export default ProtocolTable;

const Container = styled.div`
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
`;
